module.exports = __webpack_public_path__ + "static/media/bpsu.logo.240w.b85492a9.jpg";